import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { SearchHotelsComponent } from './search-hotels/search-hotels.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { CalendarComponent } from 'src/app/shared-components/calendar/calendar.component';
import { RoomComponent } from 'src/app/shared-components/traveller-count-picker/room/room.component';
import { AutosuggestPopupComponent } from 'src/app/shared-components/autosuggest-popup/autosuggest-popup/autosuggest-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
@NgModule({
    imports: [CommonModule, FormsModule, MatSelectModule, ReactiveFormsModule, OverlayModule, A11yModule, SharedComponentsModule, MatTooltipModule],
    declarations: [SearchHotelsComponent],
    exports: [SearchHotelsComponent, MatTooltipModule]
})
export class HotelsSharedComponentsModule { }
